import { graphql } from '@/gql'

export const ANNOUNCEMENTS_ALL = graphql(`
  query GetAllAnnouncements(
    $filter: AnnouncementFilter
    $first: Int
    $after: Cursor
  ) {
    announcements(
      orderBy: CREATED_AT_DESC
      first: $first
      filter: $filter
      after: $after
      condition: { active: true }
    ) {
      edges {
        node {
          ...Announcement
          read
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`)

export const ANNOUNCEMENTS_QUERY = graphql(`
  query GetAnnouncements(
    $first: Int
    $last: Int
    $before: Cursor
    $after: Cursor
    $orderBy: [AnnouncementsOrderBy!]
    $filter: AnnouncementFilter
  ) {
    announcements(
      first: $first
      last: $last
      before: $before
      after: $after
      orderBy: $orderBy
      filter: $filter
      condition: { active: true }
    ) {
      edges {
        node {
          ...Announcement
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`)

export const ANNOUNCEMENT_DEPARTMENTS = graphql(`
  query GetAnnouncementDepartments {
    departments(condition: { active: true }) {
      edges {
        node {
          id
          name
          companyId
        }
      }
    }
  }
`)

export const ANNOUNCEMENT_BY_ID = graphql(`
  query GetAnnouncementById($id: UUID!) {
    announcementById(id: $id) {
      ...Announcement
    }
  }
`)

export const ANNOUNCEMENT_CHECKBOX = graphql(`
  query allAnnouncementsCheckbox($filter: AnnouncementFilter) {
    announcements(filter: $filter, condition: { active: true }) {
      edges {
        node {
          id
        }
      }
    }
  }
`)

export const LATEST_POPUP_ANNOUNCEMENT = graphql(`
  query latestPopupAnnouncement($currentDate: Datetime, $locale: String!) {
    announcements(
      first: 1
      orderBy: CREATED_AT_DESC
      filter: {
        popup: { equalTo: true }
        published: { equalTo: true }
        locales: { anyEqualTo: $locale }
        and: [
          {
            or: [
              { publishAt: { isNull: true } }
              { publishAt: { lessThanOrEqualTo: $currentDate } }
            ]
          }
          {
            or: [
              { expireAt: { isNull: true } }
              { expireAt: { greaterThan: $currentDate } }
            ]
          }
        ]
      }
      condition: { active: true }
    ) {
      nodes {
        id
        title
        content
        userAnnouncements {
          nodes {
            userId
          }
        }
      }
    }
  }
`)

export const UNREAD_ANNOUNCEMENTS_COUNT = graphql(`
  query unreadAnnouncementsCount($filter: AnnouncementFilter) {
    announcements(filter: $filter) {
      totalCount
    }
  }
`)
